import React, { Component } from 'react'
import ArrowLeft from '../../../images/arrow-left.svg'
import PropTypes from 'prop-types'
import Modal from '../Modal'
import { formatCPF, formatCNPJ, formatAlphanumericCNPJ, isAlphanumericCNPJ } from 'utils/masks'

class DetailsModal extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    turnBack: PropTypes.func.isRequired,
    orderDetail: PropTypes.object.isRequired,
  }

  putMask(number) {
    const { t } = this.props

    if (isAlphanumericCNPJ(number)) {
      return formatAlphanumericCNPJ(number)
    }

    switch (number.length) {
      case 11:
        return formatCPF(number, t)
      case 14:
        return formatCNPJ(number, t)
      default:
        return number
    }
  }

  render() {
    const { t, closeModal, turnBack, orderDetail } = this.props

    return (
      <Modal
        title={t('totemReports.order.details.title')}
        size='sm'
        isOpen
        className='totem-report-detail-modal'
        disabledBgClickClosing
        buttonClass='totem-report-detail-modal-button'
        hideCancelButton
        confirmButtonText={
          <div style={{ display: 'flex' }}>
            <div
              style={{ width: '100%', display: 'flex', alignItems: 'center' }}
            >
              <img src={ArrowLeft} width='10' height='10' />
            </div>
            <div style={{ width: '100%', display: 'flex' }}>
              <span>{t('confirmModal.back_button')}</span>
            </div>
            <div style={{ width: '100%' }} />
          </div>
        }
        onCloseModal={closeModal}
        onConfirm={turnBack}
        contentBeforeChildren={
          <div style={{ padding: '0px 5px' }}>
            <section className='detail-modal-order-info'>
              <div className='detail-modal-order-order'>
                <h4 className='detail-order-title'>
                  {t('totem.reports.modal.order.detail.order')}
                </h4>
                <p className='detail-order-value'>{orderDetail.order}</p>
              </div>
              <div className='detail-modal-order-store'>
                <h4 className='detail-order-title'>
                  {t('totem.reports.store.hint')}
                </h4>
                <p className='detail-order-value'>{orderDetail.store}</p>
              </div>
              <div className='detail-modal-order-weight'>
                <h4 className='detail-order-title'>
                  {t('totemReports.weight')}
                </h4>
                <p className='detail-order-value'>{`${orderDetail.weight} Kg`}</p>
              </div>
            </section>
            <section className='detail-modal-order-info'>
              <div className='detail-modal-order-custumer'>
                <h4 className='detail-order-customer'>
                  {t('totem.reports.modal.order.detail.client')}
                </h4>
                <p className='detail-order-custumer-name'>
                  {orderDetail.customer}
                </p>
              </div>
              <div className='detail-modal-order-custumer-document'>
                <h4 className='detail-order-custumer-doc-title'>
                  {t('totem.reports.modal.order.detail.doc')}
                </h4>
                <p className='detail-order-customer-doc-value'>
                  {this.putMask(orderDetail.customerDocument)}
                </p>
              </div>
            </section>
          </div>
        }
      >
        <div className='detail-modal-container'>
          <table className='table-compact detail-order-modal'>
            <thead>
              <tr>
                <th>{t('totem.reports.modal.order.detail.table.products')}</th>
                <th>
                  {t('totem.reports.modal.order.detail.table.qnt.reduced')}
                </th>
                <th>{t('totemReports.weight')}</th>
              </tr>
            </thead>
            <tbody>
              {orderDetail.products.map((product) => (
                <tr key={product.description}>
                  <td>{product.description}</td>
                  <td>{product.quantity}</td>
                  <td>{`${product.weight} Kg`}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal>
    )
  }
}

export { DetailsModal }
